export default "__VITE_ASSET__B$LBbmSR__"